import TumengBlockEdit from './src/index.vue'

TumengBlockEdit.install = function(Vue) {
  Vue.component(TumengBlockEdit.name, TumengBlockEdit)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengBlockEdit)
}

export default TumengBlockEdit
